// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1WU78","faux__sidenav":"style_faux__sidenav__30EKn","main__right":"style_main__right__DL_mA"};